import { createFileRoute } from '@tanstack/react-router';
import { AutomationEditorDialog } from '@web/modules/automations/editor/automation-editor-page';

export const Route = createFileRoute('/_app/automations/$automationId')({
  component: AutomationEditorRoute,
});

function AutomationEditorRoute() {
  const { automationId } = Route.useParams();
  return <AutomationEditorDialog target={{ mode: 'edit', automationId }} />;
}
